import React from 'react'

export default function RoleCard({ selected, name, onClick }) {
    return (
        <button onClick={onClick} className={`roleCard ${selected ? "active" : ""}`}>
            {name}
        </button>
    )
}
